var Coverflow = (function () {
    var serviceUrl;
    var isMobile;
    var autoplayTime = 4000;

    var ajaxRequest = function (searchData, successCallback, errorCallback) {
        $.ajax({
            url: serviceUrl,
            type: 'GET',
            dataType: "json",
            cache: false,
            data: { method: "Search", args: { data: searchData, mobile: isMobile }, returnType: "json" },
            success: successCallback,
            error: errorCallback,
        });
    };

    var start = function (selector) {
        selector = selector || ".coverflow";
        $(selector).each(function (index, elem) {
            var $elem = $(elem);
            var searchData = $elem.data("search");
            var style = $elem.data("style") || "coverflow";
            var suppressempty = $elem.data("suppressempty");
            var suppressempty_containerid = $elem.data("suppressempty_containerid");
            var spacing = -0.3;
            var startIndex = 0;

            switch (style) {
                case "wheel":
                    spacing = 0;
                    startIndex = "center";
                    break;
                case "carousel":
                    spacing = 0;
                    startIndex = "center";
                    break;
                case "flat":
                    spacing = 0;
                    break;
                default:
                    spacing = -0.3;
                    break;
            }

            ajaxRequest(searchData, function (response) {
                var html = '<div class="flow"><ul>';
                var items = JSON.parse(response);

                for (var i = 0; i < items.length; i++) {
                    html += "<li>" +
                        "<a href='" +
                        items[i].DetailUrl +
                        "' title='" +
                        items[i].Title + " (" + items[i].MediaGroupName + " - " + items[i].MediaStatus + ")" +
                        "'>" +
                        "<img style='width:" +
                        items[i].Width +
                        "px;' data-fallback-src='" +
                        rootUrl +
                        "/images/mediagrp/leer.png' data-src='" +
                        items[i].ImageUrl +
                        "' alt='" +
                        items[i].Title +
                        "' class='thumbCoverImageEager' data-mediagroup-src='" +
                        items[i].FallbackImageUrl +
                        "' />" +
                        items[i].Status +
                        "</a>" +
                        "</li>";
                }

                $newElement = $(html);
                $elem.replaceWith($newElement);

                var carousel = $newElement.flipster({
                    buttons: true,
                    style: style,
                    suppressempty: suppressempty,
                    suppressempty_containerid: suppressempty_containerid,
                    start: startIndex,
                    spacing: spacing,
                    autoplay: autoplayTime,
                    loop: true,
                    buttonPrev: 'Zurück',
                    buttonNext: 'Weiter'
                });

                LazyLoadCovers();
            });
        });
    };

    return {
        init: function (url, mobile) {
            serviceUrl = url;
            isMobile = mobile;

            $(window).on('load', function () {
                start();
            });
        },
        reload: function (selector) {
            start(selector);
        }
    }
})();